var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 49 49"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "edit_svg__edit",
    d: "M0 38.8V49h10.2l30-30L30 8.9 0 38.8zM47.9 7.4L41.5 1c-1-1-2.7-1-3.8 0l-5 5 10.2 10.2 5-5c1-1.1 1-2.8 0-3.8z"
  })));
}
export default SvgEdit;